"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldHighlightWhenExpanded = exports.shouldHighlightWhenNotExpanded = exports.isModalType = exports.isHeaderType = exports.isTableType = exports.ItemType = exports.NavPanelUtils = void 0;
var TableTypes_1 = __importDefault(require("../Constants/TableTypes"));
var ItemType = {
    Header: {
        Storyboards: 'storyboards',
        Projects: 'projects',
        Interpretations: 'interpretations',
        Metrics: 'metrics',
        Triggers: 'triggers',
    },
    Storyboard: 'storyboard',
    Project: 'project',
    Control: 'control',
    Table: {
        DataAnalytic: TableTypes_1.default.DataAnalytic,
        Survey: TableTypes_1.default.Survey,
        EventReport: TableTypes_1.default.EventReport,
        Reporting: TableTypes_1.default.Reporting,
    },
    Records: 'records',
    Interpretation: 'interpretation',
    Metric: 'metric',
    Trigger: 'trigger',
};
exports.ItemType = ItemType;
var isTableType = function (type) { return Object.values(ItemType.Table).includes(type); };
exports.isTableType = isTableType;
var isHeaderType = function (type) { return Object.values(ItemType.Header).includes(type); };
exports.isHeaderType = isHeaderType;
var isModalType = function (type) {
    return [ItemType.Header.Triggers, ItemType.Trigger, ItemType.Header.Interpretations, ItemType.Header.Metrics].includes(type);
};
exports.isModalType = isModalType;
var shouldHighlightWhenNotExpanded = function (location, type, id, controlTestId) {
    if (type === ItemType.Header.Storyboards && location.storyboards) {
        return true;
    }
    if (type === ItemType.Header.Projects && location.projects && location.project_title_id === id) {
        return true;
    }
    if (type === ItemType.Project && location.projects === id) {
        return true;
    }
    if (type === ItemType.Control && location.controls === id) {
        return true;
    }
    if (isTableType(type) && location.control_tests === id) {
        return true;
    }
    if (type === ItemType.Records && location.control_tests === controlTestId && !location.metrics) {
        return location.interpretations === 'remediation';
    }
    if (type === ItemType.Header.Interpretations &&
        location.interpretations &&
        location.interpretations !== 'remediation' &&
        location.control_tests === controlTestId) {
        return true;
    }
    if (type === ItemType.Header.Metrics && location.metrics && location.control_tests === controlTestId) {
        return true;
    }
    return false;
};
exports.shouldHighlightWhenNotExpanded = shouldHighlightWhenNotExpanded;
var shouldHighlightWhenExpanded = function (location, type, id, controlTestId) {
    if (type === ItemType.Interpretation && location.interpretations === id) {
        return true;
    }
    if (type === ItemType.Metric && location.metrics === id) {
        return true;
    }
    if (type === ItemType.Header.Interpretations &&
        location.interpretations === 'new' &&
        location.control_tests === controlTestId) {
        return true;
    }
    if (type === ItemType.Header.Metrics && location.metrics === 'new' && location.control_tests === controlTestId) {
        return true;
    }
    if (type === ItemType.Records &&
        location.control_tests === controlTestId &&
        !location.interpretations &&
        !location.metrics) {
        return true;
    }
    if (type === ItemType.Control && location.controls === id && !location.control_tests) {
        return true;
    }
    if (type === ItemType.Project && location.projects === id && !location.controls) {
        return true;
    }
    if (type === ItemType.Header.Projects && location.projects === 'new') {
        return true;
    }
    if (type === ItemType.Storyboard && location.storyboards === id) {
        return true;
    }
    if (type === ItemType.Header.Storyboards && location.storyboards === 'new') {
        return true;
    }
    return false;
};
exports.shouldHighlightWhenExpanded = shouldHighlightWhenExpanded;
var NavPanelUtils = {
    parseLocation: function (location_pathname, location_hash, AclExceptionProjectId, AclExceptionControlId, AclExceptionControlTestId) {
        var path = location_pathname.split('/');
        var hash = location_hash.split('/');
        var location = {};
        var id;
        if (path.length > 1) {
            for (var i = 1; i < path.length; i++) {
                id = null;
                if (i % 2 !== 0) {
                    if (path[i] === 'metrics') {
                        id = parseInt(hash[1]);
                        if (isNaN(id)) {
                            id = 'new';
                        }
                    }
                    else if (path[i] === 'interpretations') {
                        if (path[i + 1] === 'remediation') {
                            id = 'remediation';
                        }
                        else if (!isNaN(parseInt(path[i + 1]))) {
                            id = parseInt(path[i + 1]);
                        }
                        else {
                            id = 'new';
                        }
                    }
                    else if (i + 1 < path.length) {
                        if (path[i + 1] === 'new') {
                            id = 'new';
                        }
                        else {
                            id = parseInt(path[i + 1]);
                        }
                    }
                    location[path[i]] = id;
                }
            }
        }
        if (!location.projects) {
            location.projects = AclExceptionProjectId ? AclExceptionProjectId : null;
        }
        if (!location.controls) {
            location.controls = AclExceptionControlId ? AclExceptionControlId : null;
        }
        if (!location.control_tests) {
            location.control_tests = AclExceptionControlTestId ? AclExceptionControlTestId : null;
        }
        return location;
    },
    shouldHighlight: function (location, type, id, expanded, controlTestId) {
        if (!expanded) {
            return shouldHighlightWhenNotExpanded(location, type, id, controlTestId);
        }
        return shouldHighlightWhenExpanded(location, type, id, controlTestId);
    },
};
exports.NavPanelUtils = NavPanelUtils;
//# sourceMappingURL=NavPanelUtils.js.map